import baseMoment from 'moment-timezone'
import { localStorageAvailable } from './index'
import _moment from '../../both/helpers/moment'
import { getUser } from './auth'

export { displayFormat, urlFormat, isAllowedDate, disallowedISOWeekdays } from '../../both/helpers/moment'

const getOptions = (inputOptions = {}) => {
  const options = Object.assign({}, {
    // defaults
    rollover_offset: -18,
    timezone: 'America/Los_Angeles',
    user: false
  }, inputOptions)

  // To use helpers/auth.js getUser() you need localStorage.
  if (!options.user && localStorageAvailable()) options.user = getUser()

  if (options.user) {
    // if timezone/rollover_offset wasn't included in the initial arguments
    if (inputOptions.timezone === undefined && options.user.timezone) options.timezone = options.user.timezone
    if (inputOptions.rollover_offset === undefined && options.user.rollover_offset !== undefined) {
      options.rollover_offset = options.user.rollover_offset
    }
  }

  if (options.timezone) options.timezone = 'America/Los_Angeles' // HACK / TEMPORARY: Override Timezone!
  return options
}

export const moment = (parse = 'today', options = {}) => {
  options = getOptions(options)
  let date = _moment(parse, options)
  if (!date) return date

  // rollover date to tomorrow
  if (parse === 'today' && 24 + options.rollover_offset <= date.format('H')) {
    date = _moment('tomorrow', options)
  }

  if (parse === 'today' || parse === 'tomorrow') {
    date = date.startOf('day')
  }

  return date
}

// Validates if the order.date is pastCutoff.  Adapted from server/api/orders/model.checkTime
// returns false or string
export function pastCutoff (date = 'today', options = {}) {
  const cutoffHour = 6
  options = getOptions(options)
  options.timezone = 'America/Los_Angeles' // Cutoff timezone, everything should be parsed in this.

  date = moment(date, options) // This date should rollover if it's 'today'...

  const now = moment(undefined, options)
  const orderDate = date.startOf('day') // start of the day of the order
  const cutoff = orderDate.clone().startOf('day').add(cutoffHour, 'hours') // eg. 6am

  const isPast = orderDate.isBefore(new Date(), 'day') // order is in the past
  const afterCutoff = now.isAfter(cutoff)

  if (isPast) {
    return `Can't modify or create an order in the past.`
  } else if (afterCutoff) {
    return `Past the cutoff (${cutoff.format('ha')}) to modify or create an order.`
  }

  return false
}

// Only validates if the current time (new Date()) would rollover to tomorrow.
export function pastRollover (options = {}) {
  options = getOptions(options)
  const time = _moment(new Date(), options)

  return (24 + options.rollover_offset <= time.format('H'))
}

export function lastChange ({
  model = {}, collection = [],
  fields = ['created_at', 'updated_at', 'deleted_at'], ago = 'ago', left = 'left',
  returnFuture = true, returnPast = true, returnSameDay = true
} = {}) {
  const now = moment(new Date())
  let date

  const forModel = (obj) => {
    if (!obj) return false
    if (!Array.isArray(fields)) {
      if (!obj[fields]) return false
      return obj[fields]
    }

    const dates = fields.map(field => obj[field]) // list of dates
    if (!dates.filter(a => a).length) return false

    return dates.filter(a => a).reduce((a, b) => moment(a).isBefore(b) && a || b) // reduce to the oldest one
  }

  if (Object.keys(model).length) date = forModel(model)
  else if (collection.length) {
    let obj = collection.reduce((a, b) => {  // find the oldest date on an object
      const aDate = forModel(a)
      const bDate = forModel(b)
      if (!aDate && !bDate) return false
      if (!aDate) return b
      if (!bDate) return a

      return moment(aDate).isBefore(bDate) && a || b
    })

    date = forModel(obj)
  }

  date = date && moment(date) || false
  if (!date) return false

  if (!returnFuture && date.isAfter(now)) return false
  if (!returnPast && date.isBefore(now)) return false
  if (!returnSameDay && date.isSame(now, 'day')) return false

  return `${baseMoment.duration(now.diff(date)).humanize()} ${now.isAfter(date) && ago || left}`
}

export default moment



// WEBPACK FOOTER //
// ./src/helpers/moment.js